<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>


        <navbar>
            <template v-slot:navbarname>
                <b-link
                        :to="{name:'Stock'}"
                        class="btn btn-primary btn-round">Back
                </b-link>
            </template>
        </navbar>
        <!--END Navbar-->

        <template v-if="group !== null">
            <h2>Edit Group: {{group.name}}</h2>
        </template>

        <b-card title="Information">
            <b-form-group class="required" label="title">
                <b-input v-model="form.name"></b-input>
            </b-form-group>
            <b-form-group class="required" label="amount" v-if="!isEditGroup">
                <b-input v-model="form.amount"></b-input>
            </b-form-group>
        </b-card>

        <b-card>
            <b-form-group label="Products" class="required">
                <v-select
                        placeholder="select products"
                        multiple
                        :reduce="product_title => product_title.product_id"
                        label="product_title"
                        v-model="form.products"
                        :options="products"></v-select>
            </b-form-group>
        </b-card>

        <template v-if="isEditGroup">
            <b-button @click="updateGroup" variant="success">{{$t('saveTitle')}}</b-button>
        </template>
        <template v-else>
            <b-button @click="storeStockGroup" variant="success">{{$t('saveTitle')}}</b-button>
        </template>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "AddGroup",
        components: {Navbar},
        data() {
            return {
                isEditGroup: false,
                products: [],
                group: null,
                form: {
                    name: null,
                    amount: null,
                    products: [],
                }
            }
        },
        methods: {
            getProducts() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'stock/group/create')
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.products = response.data.data;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            storeStockGroup() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'stock/group/store', this.form)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.created()) {
                            Notification.success(response.data.message);
                            this.$router.push({name: 'Stock'})
                        } else {
                            Notification.error(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getDetailsGroup() {
                if (this.$route.params.groupid && this.$route.params.groupid > 0) {
                    this.isEditGroup = true;
                    this.$Progress.start();
                    Http.post(Http.apiurlV2() + 'stock/group/show/' + this.$route.params.groupid)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.form.products = [];
                                this.group = response.data.data.group;
                                this.form.name = this.group.name;
                                response.data.data.products.filter(item => {
                                    this.form.products.push(item.product_id);
                                })
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            updateGroup() {
                if (this.$route.params.groupid && this.$route.params.groupid > 0) {
                    this.$Progress.start();
                    Http.post(Http.apiurlV2() + 'stock/group/update/' + this.$route.params.groupid,this.form)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                Notification.success(response.data.message);
                                this.$router.push({name: 'DetailsGroup',params:{'groupid':this.$route.params.groupid}})
                            }else {
                                Notification.error(response.data.message);

                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
        },
        created() {
            if (this.$route.params.groupid && this.$route.params.groupid > 0) {
                this.getDetailsGroup();
            }
            this.getProducts();
        }
    }
</script>

<style scoped>

</style>